import { ContentPage } from '@malesia/react-components/dist/src/components/ContentPage/ContentPage';
import { HtmlBlock } from '@malesia/react-components/dist/src/components/Front/HtmlBlock/HtmlBlock';
import { SFC } from '@malesia/react-components/dist/src/types/react';
import React from 'react';
import { useIntl } from 'react-intl';
import useSWR from 'swr';
import { loadLocationPageContent } from '../../services/directus/locationPage/loadLocationPageContent';

export const MalesiaLocationPage: SFC = () => {
    const { locale } = useIntl();
    const { data } = useSWR([locale, 'loadLocationPageContent'], loadLocationPageContent);

    return (
        <>
            <ContentPage
                image={data?.topImage}
            >
                <HtmlBlock content={data?.content ?? ''} />
            </ContentPage>
        </>
    );
};
